<template>
  <v-container>
    <v-card class="rounded-lg shadow-lg my-5">
      <v-card-text class="text-center">
        <v-img src="/media/failed.svg" alt="Failed Payment" contain height="100" class="mx-auto my-4"/>
        <h3 class="text-danger font-weight-bold my-3">
          پرداخت ناموفق
        </h3>
        <p class="body-1">
          {{ info.message }}
        </p>
        <v-divider class="my-4"></v-divider>
        <v-container>
          <v-row justify="space-between" align="center" class="rtl-layout">
            <v-col cols="6" class="text-right text--secondary">
              مبلغ :
            </v-col>
            <v-col cols="6" class="text-left font-weight-bold">
              {{ info.order.price | rial }} ریال
            </v-col>
          </v-row>
          <v-row justify="space-between" align="center" class="rtl-layout">
            <v-col cols="6" class="text-right text--secondary">
              تاریخ و ساعت :
            </v-col>
            <v-col cols="6" class="text-left font-weight-bold">
              {{ info.order.created_at | longDate }}
            </v-col>
          </v-row>
        </v-container>
        <v-btn
          color="danger"
          class="mt-5"
          large
          block
          @click="goBack"
        >
          <v-icon left>mdi-arrow-right</v-icon>
          <b>بازگشت</b>
        </v-btn>
      </v-card-text>
    </v-card>
    <div class="text-center text--secondary caption mt-5">
      تمامی حقوق این نرم افزار برای کورلند محفوظ است .
    </div>
  </v-container>
</template>

<script>
export default {
  name: 'FailedPayment',
  props: {
    info: {
      type: Object,
      required: true
    }
  },
  methods: {
    goBack() {
      this.$router.push({ name: 'home' });
    }
  }
}
</script>

<style scoped>
.rtl-layout {
  direction: rtl;
}
.shadow-lg {
  box-shadow: 0 10px 15px -3px rgba(0, 0, 0, 0.1), 0 4px 6px -2px rgba(0, 0, 0, 0.05) !important;
}
</style>
